import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { format, parseISO } from 'date-fns';
import VigoCopyableText from 'src/@vigo/vigo-copyabletext';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { FlowStatusGroupDisplay } from '..';

interface FlowStatusGridProps {
  dataSource: FlowStatusGroupDisplay[];
}

interface GpsCopyCellProps {
  latitude?: number;
  longitude?: number;
}

const GpsCopyCell = ({ latitude, longitude }: GpsCopyCellProps) => {
  if (latitude === undefined || longitude === undefined) return null;

  const coordinates = `${latitude}, ${longitude}`;

  return <VigoCopyableText value={coordinates}>{coordinates}</VigoCopyableText>;
};

const FlowStatusGrid = ({ dataSource }: FlowStatusGridProps) => {
  return (
    <Box flexGrow={1} minHeight={0} overflow={'auto'}>
      <Grid container sx={{ overflow: 'auto' }}>
        {dataSource.map(group => (
          <Grid container key={group.itemNo} sx={{ mt: 5 }}>
            <VigoTypography value={`Item No. ${group.itemNo}`} disableTranslation />

            {/* Statuses Table */}
            <Box sx={{ width: '100%', mt: 2, overflowY: 'auto' }}>
              <Table size="small" sx={{ minWidth: 600 }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: '50px' }}>Code</TableCell>
                    <TableCell sx={{ width: '150px' }}>Description</TableCell>
                    <TableCell sx={{ width: '160px' }}>Date & Time</TableCell>
                    <TableCell sx={{ width: '50px' }}>Notes</TableCell>
                    <TableCell sx={{ width: '175px' }}>GPS</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {group.statuses.map(status => {
                    const statusKey = `${group.itemNo}|${status.code}|${status.date}`;

                    return (
                      <TableRow key={statusKey}>
                        <TableCell>{status.code}</TableCell>
                        <TableCell>{status.description}</TableCell>
                        <TableCell>{format(parseISO(status.date), 'dd/MM/yyyy HH:mm:ss')}</TableCell>
                        <TableCell>{status.notes}</TableCell>
                        <TableCell>
                          <GpsCopyCell latitude={status.latitude} longitude={status.longitude} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FlowStatusGrid;
